import styled from "styled-components";


// --- RESTAURADO: Carga de la imagen de fondo ---
// Se restaura el método original para cargar la imagen.
// ¡Asegúrate de que la ruta "../../assets/icons/infra-logo.png" sea correcta en tu proyecto!
// Si la ruta es incorrecta, la imagen no se mostrará.
const BackgroundImage = require("../../assets/icons/infra-logo.png");

const brandingBackground = `
  linear-gradient(rgba(0, 52, 101, 0.8), rgba(0, 21, 51, 0.9)),
  url(${BackgroundImage})
`;

export const PageContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden; // Previene el scroll en la página principal
`;

export const BrandingPanel = styled.div`
  width: 50%;
  background-image: ${brandingBackground};
  background-size: cover;
  background-position: center;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  text-align: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const InfraLogo = styled.img`
  width: 180px;
  margin-bottom: 24px;
`;

export const Slogan = styled.h2`
  font-weight: 500;
  font-size: 1.5rem;
  max-width: 400px;
`;

export const FormPanel = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  padding: 40px;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FormContainer = styled.form`
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
`;

export const Subtitle = styled.p`
  color: #666;
  margin-bottom: 32px;
`;

export const InputGroup = styled.div`
  position: relative;
  margin-bottom: 24px;
`;

export const InputIcon = styled.div`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa;
  pointer-events: none;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 45px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
  }
`;

// --- RESTAURADO: Estilos de botones con animación original ---
const baseButtonStyles = `
  position: relative;
  width: 100%;
  padding: 14px;
  border: 2px solid transparent;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  overflow: hidden;
  transition: background-color 0.3s, color 0.3s, transform 0.2s, opacity 0.3s;

  &:disabled {
    background-color: #e0e0e0;
    color: #a0a0a0;
    cursor: not-allowed;
    transform: none;
  }

  &:disabled:hover {
    background-color: #e0e0e0;
    color: #a0a0a0;
  }

  &:disabled::before {
    display: none;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px; // Coincide con el border-radius del botón
    transform: scale(0);
    transition: transform 0.4s ease;
    pointer-events: none;
    box-sizing: border-box; // Importante para que el borde no afecte el tamaño
  }
`;

export const SubmitButton = styled.button`
  ${baseButtonStyles}
  background-color: #003465;
  color: white;

  &::before {
    border: 2px solid #003465;
  }

  &:not(:disabled):hover {
    background-color: transparent;
    color: #003465;
    transform: translateY(-2px);
  }

  &:not(:disabled):hover::before {
    transform: scale(1);
  }
`;

export const SecondaryButton = styled.button`
  ${baseButtonStyles}
  margin-top: 12px;
  background-color: #fa8a14;
  color: white;

  &::before {
    border: 2px solid #fa8a14;
  }

  &:not(:disabled):hover {
    background-color: transparent;
    color: #fa8a14;
    transform: translateY(-2px);
  }

  &:not(:disabled):hover::before {
    transform: scale(1);
  }
`;

export const ForgotPasswordLink = styled.a`
  text-align: center;
  margin-top: 24px;
  color: #007bff;
  text-decoration: none;
  font-size: 0.9rem;

  &:hover {
    text-decoration: underline;
  }
`;

export const RecaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const PasswordToggleIcon = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa;
  cursor: pointer;
`;
// Agrega esto a tu archivo LoginPage.styles.ts

// ... tus estilos existentes

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 450px;
  position: relative;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h3 {
    margin: 0;
    font-size: 1.5rem;
    color: #333;
  }
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #888;
  padding: 0;

  &:hover {
    color: #333;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px; /* Espacio entre los botones */
  margin-top: 25px;
`;